(function (angular, app) {
   "use strict";
    
   // Slider
   angular.module(app.modules.scoring.name)
      .directive(app.modules.scoring.directives.club, ClubDirective);
      
   ClubDirective.$inject = ["$timeout"
        , app.modules.common.constants.equipmentlist
   ];
   
   function ClubDirective($timeout
       , ggEquipment
       ){
      
      var ctrl = this;
      
      return {
         restrict : "A"
         , templateUrl : "app/scoring/directives/club.html"
         , scope: {
            callback : "&"
         }
         , link : function (scope, element, attrs) {
            
            scope.club = {
               holeNumber: 0
               , par: 4
               , currentValue: ""
               , selectedClub : {}
               , list: ggEquipment
               , status : {
                  isopen: false
               }
               , toggled : function(open) {}
               , f: {
                   select : function(v, c){
                     scope.club.currentValue = v;
              
                     var club = {};
                     club.name = v;
                     club.code = c;
                     scope.club.selectedClub = club;
                            
                     var data = {
                        holeNumber : scope.club.holeNumber
                        , par: scope.club.par
                        , value: scope.club.currentValue
                     }
               
                     // Parent Callback
                     scope.callback()(data);
                  }
                  , toggleDropdown : function($event) {
                     $event.preventDefault();
                     $event.stopPropagation();
                     scope.status.isopen = !scope.status.isopen;
                  }
               }
            }

            
            var loadOptions = function (objStr, isUpdate) {
               if (objStr) {
                  var obj = JSON.parse(objStr);
                  var newValue = null;
                  if (obj) {
                     if (obj.par) {
                        scope.club.par = Number(obj.par);
                     }
                     if (obj.holeNumber) {
                        scope.club.holeNumber = Number(obj.holeNumber);
                     }

                     if (obj.currentValue) {
                        newValue = obj.currentValue;
                     } else {
                        newValue = "";
                     }
                  }

                  if (newValue != scope.club.currentValue) {
                     if (newValue != "") {
                        var clb = { name: "", code: "" };
                        for (var s = 0; s < scope.club.list.length; s++) {
                           if (scope.club.list[s].name == newValue) {
                              clb = scope.club.list[s];
                              break;
                           }
                        }
                        scope.club.f.select(clb.name, clb.code);
                     } else {
                        scope.club.f.select("", null);
                     }
                  } else {
                     scope.club.currentValue = newValue;
                  }
               }
            }

            // Watch for Change in Options
            attrs.$observe('options', function () {
               var optStr = attrs.options;
               if (optStr != "") {
                  loadOptions(optStr, true);
               }
            });

         }
      }
   }
}(angular, app));
